import React, { Component } from 'react'
import Page from './Page'
import Results from '../components/Results'

class CategoryPage extends Component {
  render () {
    return (
      <Page title='Kategorie'>

        <Results type='mosaic'
                 showCategoryLinks={false}
                 categoryId={this.props.match.params.id} />

      </Page>
    )
  }
}

export default CategoryPage



// WEBPACK FOOTER //
// ./src/containers/CategoryPage.js